// extracted by mini-css-extract-plugin
export default {"movie-card":"MovieCard_movie-card__6Jy8u","btn":"MovieCard_btn__4kYrG"};